module.exports = __webpack_public_path__ + "img/img3.91222f30.png";